import { Controller } from 'react-hook-form'
import { Box, Flex, Radio } from '@chakra-ui/react'
import helperTexts from '../../helperTexts.json'
import { StyledInput, UnderlineError } from '../styled'
import { hostPortRegex } from "../formUtils";
import {useEffect} from "react";
import { FormLabel } from '../../common/FormLabel'

export const SocketAcceptorHostPort = ({ field, form, control, isAcceptor, setValue, errors }) => {
    useEffect(() => {
        if (!isAcceptor && errors['socketAcceptorHostPort']) {
            form.clearErrors('socketAcceptorHostPort')
        }
    }, [isAcceptor, errors, form])

    const isDisabled = field.isDisabled

    return (
    <Box width="320px" fontWeight='500'>
        <Controller
            name="connectionType"
            control={control}
            render={({ field }) => (
                <Radio
                    {...field}
                    size="md"
                    marginBottom={2}
                    isDisabled={isDisabled}
                    isChecked={isAcceptor}
                    onChange={(e) => setValue('connectionType', e.target.checked ? 'acceptor' : 'initiator')}
                >
                    Acceptor
                </Radio>
            )}
        />
        <FormLabel
            required
            disabled={!isAcceptor || isDisabled}
            helperText={helperTexts.socketAcceptorHostPort}
        >
            {field.label}
        </FormLabel>
        <Flex alignItems="center">
            <Controller
                name={'socketAcceptorHostPort'}
                control={control}
                rules={{
                    required: isAcceptor,
                    validate: () => {
                        if (isAcceptor && !form.getValues('socketAcceptorHostPort').match(hostPortRegex)) {
                            return 'Incorrect format. Should be "host:port"'
                        }
                        return true
                    }
                }}
                render={({ field }) => (
                    <StyledInput 
                        {...field}
                        style={{ font: 'var(--code-font)' }}
                        marginBottom={2}
                        placeholder="host:port"
                        isDisabled={!isAcceptor || isDisabled}
                        isInvalid={!!errors['socketAcceptorHostPort']}
                    />
                )}
            />
        </Flex>
        {!!errors['socketAcceptorHostPort'] &&
            <UnderlineError>
                {errors['socketAcceptorHostPort'].type === 'required'
                    ? 'Required'
                    : errors['socketAcceptorHostPort'].message}
            </UnderlineError>
        }
    </Box>
    )
}
